import { useCallback, useMemo } from "react";
import {
  BaseAccommodationType,
  OccupationFilterType,
  OccupationType,
} from "../../domain/Occupancy.entity";
import { occupationTypesMessages } from "../../messages";
import { useIntl } from "react-intl";

export function useOccupations() {
  const intl = useIntl();

  const occupationTypeOptions: { value: string; label: string }[] = useMemo(
    () => [
      {
        value: OccupationType.OCCUPANCY_TYPE,
        label: intl.formatMessage(occupationTypesMessages.occupancyTypeMode),
      },
      {
        value: OccupationType.PAX_TYPE,
        label: intl.formatMessage(occupationTypesMessages.paxTypeMode),
      },
    ],
    [intl]
  );

  const occupationFilterOptions: { value: string; label: string }[] = useMemo(
    () => [
      {
        value: OccupationFilterType.NO_FILTER,
        label: intl.formatMessage(occupationTypesMessages.optionTypeWithoutFilter),
      },
      {
        value: OccupationFilterType.PER_PERSON,
        label: intl.formatMessage(occupationTypesMessages.optionTypePerPerson),
      },
      {
        value: OccupationFilterType.FOR_ADULTS_CHILDREN,
        label: intl.formatMessage(occupationTypesMessages.optionTypeForAdultsChildren),
      },
      {
        value: OccupationFilterType.FOR_ADULTS_CHILDREN_BABIES,
        label: intl.formatMessage(occupationTypesMessages.optionTypeForAdultsChildrenBabies),
      },
      {
        value: OccupationFilterType.FOR_ADULTS_TEENS_CHILDREN,
        label: intl.formatMessage(occupationTypesMessages.optionTypeForAdultsTeensChildren),
      },
      {
        value: OccupationFilterType.FOR_ADULTS_TEENS_CHILDREN_BABIES,
        label: intl.formatMessage(occupationTypesMessages.optionTypeForAdultsTeensChildrenBabies),
      },
      {
        value: OccupationFilterType.FOR_SENIORS_ADULTS_TEENS_CHILDREN_BABIES,
        label: intl.formatMessage(
          occupationTypesMessages.optionTypeForSeniorsAdultsTeensChildrenBabies
        ),
      },
    ],
    [intl]
  );

  const getOccupationTypeSelected = useCallback(
    (occupationType: OccupationType) => {
      return (
        occupationTypeOptions.find(({ value }) => value === occupationType) ||
        occupationTypeOptions[0]
      );
    },
    [occupationTypeOptions]
  );

  const baseAccommodationTypeOptions: { value: string; label: string }[] = useMemo(
    () => [
      {
        value: BaseAccommodationType.PAX_TYPE,
        label: intl.formatMessage(occupationTypesMessages.baseAccommodationTypePax),
      },
      {
        value: BaseAccommodationType.ADULTS_TYPE,
        label: intl.formatMessage(occupationTypesMessages.baseAccommodationTypeAdults),
      },
    ],
    [intl]
  );

  const getBaseAccommodationTypeSelected = useCallback(
    (baseAccommodationType: BaseAccommodationType) => {
      return (
        baseAccommodationTypeOptions.find(({ value }) => value === baseAccommodationType) ||
        baseAccommodationTypeOptions[0]
      );
    },
    [baseAccommodationTypeOptions]
  );

  const getOccupationFilterTypeSelected = useCallback(
    (occupationFilterType: OccupationFilterType) => {
      return (
        occupationFilterOptions.find(({ value }) => value === occupationFilterType) ||
        occupationFilterOptions[0]
      );
    },
    [occupationFilterOptions]
  );

  return {
    occupationTypeOptions,
    occupationFilterOptions,
    baseAccommodationTypeOptions,
    getOccupationTypeSelected,
    getOccupationFilterTypeSelected,
    getBaseAccommodationTypeSelected,
  };
}
